import {status} from '../../../../utils/constant';
import networkEnrollmentService from './LiveNetworkEnrollmentService';

export function getPendingOrRejectedInvitations(invitingId) {
  return networkEnrollmentService.searchInvitations({statuses: [status.PENDING, status.REJECTED], ...invitingId});
}

export default {
  getPendingOrRejectedInvitations
};
